import { rollText } from '@scale/utilities';

const identity = (element, name) => `${element.closest('[data-key]')?.dataset.key ?? ''}:${name}`;
const digits = (text) => Number(text.replace(/\D/g, ''));

export const shownText = (element) => (element.lastElementChild ?? element).textContent.trim();

export function rollAmount(element, text) {
  const previous = shownText(element);
  if (previous !== text) rollText(element, text, digits(text) < digits(previous) ? -1 : 1);
}

export function followCartChange(root, event) {
  const amounts = new Map();
  for (const element of root.querySelectorAll('[data-cart-roll]')) {
    amounts.set(identity(element, element.dataset.cartRoll), shownText(element));
  }
  const folds = new Map();
  for (const fold of root.querySelectorAll('[data-cart-fold]')) {
    folds.set(identity(fold, fold.dataset.cartFold), fold.classList.contains('is-open') && settled(fold.firstElementChild));
  }

  event.promise?.then(() => {
    const turned = [];
    for (const fold of root.querySelectorAll('[data-cart-fold]')) {
      const content = folds.get(identity(fold, fold.dataset.cartFold));
      if (content === undefined || Boolean(content) === fold.classList.contains('is-open')) continue;
      turned.push(fold);
      if (content) fold.firstElementChild.replaceWith(content);
      else fold.classList.add('is-new');
    }

    for (const element of root.querySelectorAll('[data-cart-roll]')) {
      const previous = amounts.get(identity(element, element.dataset.cartRoll));
      const next = shownText(element);
      if (!previous || previous === next || turned.some((fold) => fold.contains(element))) continue;
      element.textContent = previous;
      rollAmount(element, next);
    }
  }).catch(() => {});
}

function settled(content) {
  const copy = content.cloneNode(true);
  for (const element of copy.querySelectorAll('[data-cart-roll]')) {
    element.textContent = shownText(element);
    element.classList.remove('is-pending');
  }
  return copy;
}
